import { render, staticRenderFns } from "./clientConfigList.vue?vue&type=template&id=46b817f8&scoped=true&"
import script from "./clientConfigList.vue?vue&type=script&lang=ts&"
export * from "./clientConfigList.vue?vue&type=script&lang=ts&"
import style0 from "./clientConfigList.vue?vue&type=style&index=0&id=46b817f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b817f8",
  null
  
)

export default component.exports